'use client'

import { css, Global as EmGlobal } from '@emotion/react'
import { FC } from 'react'
import { theme } from './theme'

const global = css`
  :root {
    /* System font stack matching native app */
    --font-family-sans:
      system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica,
      Arial, sans-serif;
    --font-family-mono:
      SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New',
      monospace;

    --primary-color: #27b1c6;
    --secondary-color: #59cda1;

    --min-width: 320px;
    --header-height: 72px;
    --section-margin: 140px;

    ${theme.breakpoints.down('sm')} {
      --header-height: 56px;
      --section-margin: 80px;
    }

    --toastify-color-light: #1c1c1e;
    --toastify-color-dark: #1c1c1e;
    --toastify-color-info: #27b1c6;
    --toastify-color-success: #59cda1;
    --toastify-color-warning: #f1c40f;
    --toastify-color-error: #ef4444;
    --toastify-color-transparent: rgba(28, 28, 30, 0.9);
    --toastify-text-color-light: #f0f0f1;
    --toastify-text-color-dark: #f0f0f1;
  }

  * {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
  }

  html {
    min-width: var(--min-width);
    color-scheme: dark;
  }

  html,
  body {
    height: 100%;
  }

  body {
    min-height: 100vh;
    font-smooth: always;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    font-family: var(--font-family-sans);
    background-color: #131313;
    color: #f0f0f1;
  }

  /* Dark mode autofill styling */
  input:-webkit-autofill,
  input:-webkit-autofill:hover,
  input:-webkit-autofill:focus,
  input:-webkit-autofill:active {
    -webkit-box-shadow: 0 0 0 100px #1c1c1e inset !important;
    -webkit-text-fill-color: #f0f0f1 !important;
    caret-color: #f0f0f1 !important;
    border-color: #2a2a2a !important;
  }

  @keyframes fade-in {
    from {
      opacity: 0;
    }
  }

  @keyframes fade-out {
    to {
      opacity: 0;
    }
  }

  ::view-transition-old(page) {
    animation: 90ms cubic-bezier(0.4, 0, 1, 1) both fade-out;
  }

  ::view-transition-new(page) {
    animation: 210ms cubic-bezier(0, 0, 0.2, 1) 90ms both fade-in;
  }

  /* Prevent FOUC (Flash of Unstyled Content) */
  .no-fouc {
    view-transition-name: none;
  }

  /* Scrollbar styling for dark mode */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #131313;
  }

  ::-webkit-scrollbar-thumb {
    background: #2a2a2a;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #3a3a3a;
  }

  /* Light-mode scrollbar override for home pages */
  html:has(.home-wrapper) {
    color-scheme: light;

    ::-webkit-scrollbar-track {
      background: #ffffff;
    }

    ::-webkit-scrollbar-thumb {
      background: #d1d5db;
    }

    ::-webkit-scrollbar-thumb:hover {
      background: #9ca3af;
    }
  }
`

const Global: FC = () => {
  return <EmGlobal styles={global} />
}

export default Global
